var _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.42,4.15c-7.84,0-14.23,6.38-14.23,14.23,0,2.18.49,4.29,1.47,6.26,0,0,.26.53.32.63l11.38,18.62c.23.37.63.6,1.07.6s.84-.23,1.07-.6l11.39-18.65.3-.6c.97-1.98,1.46-4.08,1.46-6.26,0-7.85-6.38-14.23-14.23-14.23ZM34.93,23.54s0,0,0,0l-10.51,17.3-10.27-16.8-.25-.5c-.8-1.63-1.21-3.37-1.21-5.16,0-6.47,5.26-11.73,11.73-11.73s11.73,5.26,11.73,11.73c0,1.79-.41,3.53-1.21,5.16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.42,11.39c-3.9,0-7.07,3.17-7.07,7.07s3.17,7.07,7.07,7.07,7.07-3.17,7.07-7.07-3.17-7.07-7.07-7.07ZM24.42,23.02c-2.52,0-4.57-2.05-4.57-4.57s2.05-4.57,4.57-4.57,4.57,2.05,4.57,4.57-2.05,4.57-4.57,4.57Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location_icon.f27864f21d9913583c47f8c45be0e234.svg";
export { ForwardRef as ReactComponent };